import {useMemo} from "react";
import {GeneRefs} from "../types/Types";
import {useFileRefs} from "./useJsonLoader";


export function useGeneRefs() {
  const refs = useFileRefs();

  return useMemo(() => {
    const map: Record<number, GeneRefs> = {};

    refs?.forEach((gene) => {
      map[gene.e] = gene;
    });

    return Object.keys(map).length === 0 ? undefined : map;
  }, [refs]);
}
